import { ConnectComponent } from '../../../_components/ConnectComponent'
import { ExpiredTablePresenter } from './ExpiredTable.presenter'
import { ExpiredTableView } from './ExpiredTable.view'

export const ExpiredTable = ConnectComponent(
  ExpiredTableView,
  ExpiredTablePresenter,
)
